import type { CardViewModel } from '@pesto/features/src/Cards/types/Cards.types';

import { Button } from '@pesto/ui/components/Button';
import { ShoppingCart } from 'lucide-react';
import { useState } from 'react';

import { SimulatePurchaseDialog } from './SimulatePurchaseDialog';

interface SimulatePurchaseButtonProps {
  cards: CardViewModel[];
}

export const SimulatePurchaseButton = ({ cards }: SimulatePurchaseButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setIsDialogOpen(true)}>
        <ShoppingCart className="h-4 w-4" />
        Simulate purchase
      </Button>
      <SimulatePurchaseDialog cards={cards} isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </>
  );
};
